import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { PartialStore } from '../types'

type VehicleReadinessStore = PartialStore<typeof vehicleReadinessSlice>

type VehicleReadinessState = {
  expandedDepotIds: Record<string, true>
}

const initialState: VehicleReadinessState = {
  expandedDepotIds: {}
}

const vehicleReadinessSlice = createSlice({
  name: 'vehicleReadiness',
  initialState,
  reducers: {
    setExpanded(state, action: PayloadAction<{ depotId: string; expanded: boolean }>) {
      const { depotId, expanded } = action.payload
      if (expanded) {
        state.expandedDepotIds[depotId] = true
      } else {
        delete state.expandedDepotIds[depotId]
      }
    }
  }
})

export default vehicleReadinessSlice.reducer

const selectExpandedMap = (state: VehicleReadinessStore) => state.vehicleReadiness.expandedDepotIds

export function useVehicleReadinessExpansion(depotId?: string) {
  const dispatch = useDispatch()
  const expandedMap = useSelector(selectExpandedMap)
  const isExpanded = depotId ? Boolean(expandedMap[depotId]) : false

  const setExpanded = useCallback(
    (expanded: boolean) => {
      if (!depotId) return
      dispatch(vehicleReadinessSlice.actions.setExpanded({ depotId, expanded }))
    },
    [dispatch, depotId]
  )

  return { isExpanded, setExpanded }
}
